module.exports = __webpack_public_path__ + "static/CodeCup1-80781da11af897ecbe504cb36b9be650.jpg";